import { Plus } from "lucide-react";

import { Button } from "@/shared/ui/button";

const collections = [
  {
    title: "Collection 1",
    description: "This is a description of collection 1.",
  },
  {
    title: "Collection 2",
    description: "This is a description of collection 2.",
  },
  {
    title: "Collection 3",
    description: "This is a description of collection 3.",
  },
] as const;

export function CollectionsOverview() {
  return (
    <section className="space-y-6 pt-6 pl-4">
      <header className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="space-y-3">
          <p className="text-xs uppercase tracking-[0.35em] text-ink-500">
            Collections
          </p>
          <div className="space-y-2">
            <h1 className="font-display text-3xl text-ink-900 md:text-4xl">
              Collections
            </h1>
            <p className="max-w-2xl text-sm text-ink-600 md:text-base">
              Assemble and curate the intelligence sets that power your race
              strategy workflows.
            </p>
          </div>
        </div>
        <Button size="lg" className="gap-2">
          <Plus className="h-4 w-4" aria-hidden="true" />
          Add Collection
        </Button>
      </header>

      <div className="grid gap-6 md:grid-cols-3">
        {collections.map((collection) => (
          <article
            key={collection.title}
            className="rounded-xl border border-grid-200 bg-white p-6 shadow-sm shadow-ink-900/5"
          >
            <h2 className="text-base font-semibold text-ink-900">
              {collection.title}
            </h2>
            <p className="mt-2 text-sm text-ink-600">
              {collection.description}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}
